export default __webpack_public_path__ + "images/resource-library-bg.png?894561c2287662eab596397b00cbaef9";